/**
 * Thread Hook
 * Custom hook for fetching message threads (replies)
 */

import { useQuery } from '@tanstack/react-query';
import { messagesService } from '@/services/messages.service';
import type { Message } from '@/types/api.types';

export const useThread = (messageId: string | null) => {
  return useQuery<Message[]>({
    queryKey: ['thread', messageId],
    queryFn: () => {
      if (!messageId) throw new Error('Message ID is required');
      return messagesService.getThread(messageId);
    },
    enabled: !!messageId,
    staleTime: 30000, // 30 seconds
    refetchOnWindowFocus: false,
  });
};
